<div class="overlay"></div>
<div class="modal-signup">
    <div class="logo-container">
        <img src="../../../assets/login/logo.png" alt="Datacore Logo" />
        <button class="close-btn" (click)="close()">✕</button>
    </div>

    <div class="modal-body">
        <div class="header">
            <h2>{{ 'signup.TITLE' | translate }}</h2>
            <p>
                {{ 'signup.DESCRIPTION' | translate }}
            </p>
        </div>

        <form (ngSubmit)="onSubmit()" class="form">
            <div class="checkbox">
                <label>
                    <input
                        type="checkbox"
                        [(ngModel)]="isProfessional"
                        name="isProfessional"
                    />
                    <span>{{ 'signup.PROFESSIONAL.CHECKBOX' | translate }}</span
                    >
                </label>
            </div>

            <div *ngIf="isProfessional" class="professional-section">
                <label>{{ 'signup.PROFESSIONAL.COMPANY_LABEL' | translate }}</label>
                <nz-select
                    nzShowSearch
                    [(ngModel)]="company"
                    class="custom-nz-select"
                    required
                    name="company"
                >
                    <nz-option
                        *ngFor="let opt of companies"
                        [nzLabel]="lang === 'vi' ? opt.nameVn : opt.nameEn"
                        [nzValue]="opt.nameEn"
                    >
                    </nz-option>
                </nz-select>

                <div *ngIf="company == 'Other'" class="custom-input-group">
                    <label class="input-label">{{ 'signup.PROFESSIONAL.OTHER_LABEL' | translate }}</label>

                    <div class="input-wrapper">
                        <div class="input-prefix">{{ 'signup.PROFESSIONAL.OTHER' | translate }}</div>

                        <input
                            [(ngModel)]="otherCompany"
                            type="text"
                            class="input-field"
                            placeholder="{{ 'signup.PROFESSIONAL.OTHER_PLACEHOLDER' | translate }}"
                            name="otherCompany"
                        />

                        <button type="button" class="clear-btn">✖</button>
                    </div>
                </div>

                <label>{{ 'signup.PROFESSIONAL.ORG_EMAIL_LABEL' | translate }}</label>
                <input
                    type="email"
                    placeholder="{{ 'signup.PROFESSIONAL.ORG_EMAIL_PLACEHOLDER' | translate }}"
                    [(ngModel)]="organizationEmail"
                    name="organizationEmail"
                    [required]="isProfessional"
                    pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                    #organizationEmailRef="ngModel"
                />
                <div
                    class="error"
                    *ngIf="
                        (submitted || organizationEmailRef.touched) &&
                        organizationEmailRef.invalid
                    "
                >
                    <div *ngIf="organizationEmailRef.errors?.required">
                        {{ 'signup.PROFESSIONAL.ORG_EMAIL_REQUIRED' | translate }}
                    </div>
                    <div *ngIf="organizationEmailRef.errors?.pattern">
                        {{ 'signup.PROFESSIONAL.ORG_EMAIL_INVALID' | translate }}
                    </div>
                </div>

                <label>{{ 'signup.PROFESSIONAL.PROFILE_LABEL' | translate }}</label>
                <input
                    type="url"
                    placeholder="{{ 'signup.PROFESSIONAL.PROFILE_PLACEHOLDER' | translate }}"
                    [(ngModel)]="linkedinUrl"
                    name="linkedinUrl"
                    [required]="isProfessional"
                    #linkedinUrlRef="ngModel"
                    pattern="^(https?://).*$"
                />
                <div
                    class="error"
                    *ngIf="
                        (submitted || linkedinUrlRef.touched) &&
                        linkedinUrlRef.invalid
                    "
                >
                    <div *ngIf="linkedinUrlRef.errors?.required">
                        {{ 'signup.PROFESSIONAL.PROFILE_REQUIRED' | translate }}
                    </div>
                    <div *ngIf="linkedinUrlRef.errors?.pattern">
                        {{ 'signup.PROFESSIONAL.PROFILE_INVALID' | translate }}
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <label>{{ 'signup.FORM.USERNAME_LABEL' | translate }}</label>
                    <input
                        type="text"
                        placeholder="{{ 'signup.FORM.USERNAME_PLACEHOLDER' | translate }}"
                        [(ngModel)]="username"
                        (ngModelChange)="userNameChange()"
                        name="username"
                        minlength="2"
                        maxlength="50"
                        #usernameRef="ngModel"
                        required
                    />
                    <div
                        class="error"
                        *ngIf="
                            (submitted || usernameRef.touched) &&
                            usernameRef.invalid
                        "
                    >
                        <div *ngIf="usernameRef.errors?.required">
                            {{ 'signup.FORM.USERNAME_REQUIRED' | translate }}
                        </div>
                        <div *ngIf="usernameRef.errors?.minlength">
                            {{ 'signup.FORM.USERNAME_MIN' | translate }}
                        </div>
                        <div *ngIf="usernameRef.errors?.maxlength">
                            {{ 'signup.FORM.USERNAME_MAX' | translate }}
                        </div>
                        <div *ngIf="usernameRef.errors?.pattern">
                            {{ 'signup.FORM.USERNAME_PATTERN' | translate }}
                        </div>
                    </div>
                    <div *ngIf="usernameError" class="error">
                        {{ 'signup.FORM.USERNAME_EXIST' | translate }}
                    </div>
                </div>
                <div class="col">
                    <label>{{ 'signup.FORM.FULLNAME_LABEL' | translate }}</label>
                    <input
                        type="text"
                        placeholder="{{ 'signup.FORM.FULLNAME_PLACEHOLDER' | translate }}"
                        [(ngModel)]="fullname"
                        name="fullname"
                        #fullnameRef="ngModel"
                        required
                    />
                    <div
                        class="error"
                        *ngIf="
                            (submitted || fullnameRef.touched) &&
                            fullnameRef.invalid
                        "
                    >
                        <div *ngIf="fullnameRef.errors?.required">
                            {{ 'signup.FORM.FULLNAME_REQUIRED' | translate }}
                        </div>
                    </div>
                </div>
            </div>

            <label>{{ 'signup.FORM.EMAIL_LABEL' | translate }}</label>
            <input
                type="text"
                placeholder="{{ 'signup.FORM.EMAIL_PLACEHOLDER' | translate }}"
                [(ngModel)]="email"
                name="email"
                #emailRef="ngModel"
                required
                pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
            />
            <div class="error" *ngIf="emailRef.touched && emailRef.invalid">
                <div *ngIf="emailRef.errors?.required">{{ 'signup.FORM.EMAIL_REQUIRED' | translate }}</div>
                <div *ngIf="emailRef.errors?.pattern">
                    {{ 'signup.FORM.EMAIL_INVALID' | translate }}
                </div>
            </div>

            <div class="mobile-company">
                <label>{{ 'signup.PROFESSIONAL.COMPANY_LABEL' | translate }}</label>
                <nz-select
                    nzShowSearch
                    [(ngModel)]="company"
                    class="custom-nz-select"
                    required
                    name="company"
                >
                    <nz-option
                        *ngFor="let opt of companies"
                        [nzLabel]="opt.nameEn"
                        [nzValue]="opt.nameEn"
                    >
                    </nz-option>
                </nz-select>

                <div *ngIf="company == 'Other'" class="custom-input-group">
                    <label class="input-label">{{ 'signup.PROFESSIONAL.OTHER_LABEL' | translate }}</label>

                    <div class="input-wrapper">
                        <input
                            [(ngModel)]="otherCompany"
                            type="text"
                            class="input-field"
                            placeholder="{{ 'signup.PROFESSIONAL.OTHER_PLACEHOLDER' | translate }}"
                            name="otherCompany"
                        />
                    </div>
                </div>
            </div>

            <label>{{ 'signup.FORM.PASSWORD_LABEL' | translate }}</label>
            <div class="password-wrapper">
                <input
                    [type]="showPassword ? 'text' : 'password'"
                    placeholder="{{ 'signup.FORM.PASSWORD_PLACEHOLDER' | translate }}"
                    [(ngModel)]="password"
                    name="password"
                    #passwordRef="ngModel"
                    required
                    pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$"
                    minlength="8"
                />
                <button type="button" class="toggle" (click)="togglePassword()">
                    <i
                        [ngClass]="
                            showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'
                        "
                    ></i>
                </button>
            </div>
            <div
                class="error"
                *ngIf="
                    (submitted || passwordRef.touched) && passwordRef.invalid
                "
            >
                <div *ngIf="passwordRef.errors?.required">
                    {{ 'signup.FORM.PASSWORD_REQUIRED' | translate }}
                </div>
                <div *ngIf="passwordRef.errors?.pattern">
                    {{ 'signup.FORM.PASSWORD_PATTERN' | translate }}
                </div>
                <div *ngIf="passwordRef.errors?.minlength">
                    {{ 'signup.FORM.PASSWORD_MIN' | translate }}
                </div>
            </div>

            <label>{{ 'signup.FORM.CONFIRM_PASSWORD_LABEL' | translate }}</label>
            <div class="password-wrapper">
                <input
                    [type]="showConfirmPassword ? 'text' : 'password'"
                    placeholder="{{ 'signup.FORM.CONFIRM_PASSWORD_PLACEHOLDER' | translate }}"
                    [(ngModel)]="confirmPassword"
                    name="confirmPassword"
                    #confirmPasswordRef="ngModel"
                    required
                    pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$"
                    minlength="8"
                />
                <button
                    type="button"
                    class="toggle"
                    (click)="toggleConfirmPassword()"
                >
                    <i
                        [ngClass]="
                            showConfirmPassword
                                ? 'fa fa-eye-slash'
                                : 'fa fa-eye'
                        "
                    ></i>
                </button>
            </div>
            <div
                class="error"
                *ngIf="
                    (submitted || confirmPasswordRef.touched) &&
                    confirmPasswordRef.invalid
                "
            >
                <div *ngIf="confirmPasswordRef.errors?.required">
                    {{ 'signup.FORM.CONFIRM_PASSWORD_REQUIRED' | translate }}
                </div>
                <div *ngIf="confirmPasswordRef.errors?.pattern">
                    {{ 'signup.FORM.CONFIRM_PASSWORD_PATTERN' | translate }}
                </div>
                <div *ngIf="confirmPasswordRef.errors?.minlength">
                    {{ 'signup.FORM.CONFIRM_PASSWORD_MIN' | translate }}
                </div>
            </div>

            <div *ngIf="registerFail" class="wrong">
                <!-- Information incorrect!! -->
            </div>
            <div class="terms">
                <label>
                    <input type="checkbox" [(ngModel)]="agree" name="agree" />
                    <div>
                        {{ 'signup.TERMS.TEXT' | translate }}
                    <a [routerLink]="['/', lang, RouterPath.DOCS, RouterPath.TERMS]" target="_blank" rel="noopener"
                        >{{ 'signup.TERMS.TERMS' | translate }}</a
                    >
                    {{ 'signup.TERMS.AND' | translate }}
                    <a [routerLink]="['/', lang, RouterPath.DOCS, RouterPath.POLICY]" target="_blank" rel="noopener"
                        >{{ 'signup.TERMS.PRIVACY' | translate }}</a
                    >.
                    </div>
                </label>
            </div>

            <button
                type="submit"
                class="signup-btn"
                [disabled]="!isFormValid()"
            >
                {{ 'signup.BUTTONS.SIGNUP' | translate }}
            </button>

            <div class="divider">
                <span>{{ 'signup.DIVIDER' | translate }}</span>
            </div>

            <button
                type="button"
                class="google-btn"
                (click)="signupWithGoogle()"
            >
                <img
                    src="assets/icons/icon-google.svg"
                    alt="Google"
                />
                {{ 'signup.BUTTONS.SIGNUP_GOOGLE' | translate }}
            </button>

            <p class="footer">
                {{ 'signup.FOOTER.TEXT' | translate }}
                <a href="#" (click)="switchToLogin()">{{ 'signup.FOOTER.LOGIN' | translate }}</a>
            </p>
        </form>
    </div>
</div>
